<classic-report [report]="this.reportVariant" [reportName]="'Outstanding Returned Certificates Report'"
  [defaultDisplayColumns]="this.defaultDisplayColumns" [dateFilterTypes]="this.dateFilters"
  [groupByColumns]="this.groupByColumns" [matSortActive]="'returnDate'" [matSortDirection]="'desc'">
</classic-report>